"use strict";
import { COLORS } from "./chartColors";
const formatStateName = (stateName) => {
  return stateName.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
};
export const jobCountStateTransformer = (data, selectedEntities, selectedStates = []) => {
  const monthlyStateCounts = {};
  const allStates = /* @__PURE__ */ new Set();
  Object.entries(data).forEach(([key, value]) => {
    const [entity_id, year, month] = key.split("_");
    const monthLabel = `${year}-${String(month).padStart(2, "0")}`;
    const isAllSelected = selectedEntities == null ? void 0 : selectedEntities.some((entity) => entity.name === "All");
    const isEntitySelected = selectedEntities == null ? void 0 : selectedEntities.some(
      (entity) => entity.id.toString() === entity_id
    );
    if (selectedEntities && !isAllSelected && !isEntitySelected) {
      return;
    }
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        const state = record.state || "Unknown";
        const isAllStatesSelected = selectedStates == null ? void 0 : selectedStates.some(
          (stateFilter) => stateFilter.name === "All"
        );
        const isStateSelected = selectedStates == null ? void 0 : selectedStates.some(
          (stateFilter) => stateFilter.name === formatStateName(state)
        );
        if (selectedStates && selectedStates.length > 0 && !isAllStatesSelected && !isStateSelected) {
          return;
        }
        if (!monthlyStateCounts[monthLabel]) {
          monthlyStateCounts[monthLabel] = {};
        }
        allStates.add(state);
        monthlyStateCounts[monthLabel][state] = (monthlyStateCounts[monthLabel][state] || 0) + 1;
      });
    }
  });
  const sortedLabels = Object.keys(monthlyStateCounts).sort();
  const datasets = Array.from(allStates).map((state, index) => ({
    label: formatStateName(state),
    data: sortedLabels.map((label) => monthlyStateCounts[label][state] || 0),
    backgroundColor: COLORS[index % COLORS.length],
    borderWidth: 1,
    stack: "jobStates"
  }));
  return {
    labels: sortedLabels.map((period) => {
      const [year, month] = period.split("-");
      return `${month}/${year}`;
    }),
    datasets
  };
};
